import React from 'react'
import styled from '@emotion/styled'
import Helmet from 'react-helmet'
import parse from 'html-react-parser'
import GlobalCSS from 'src/components/GlobalCSS'
import SEO from 'src/components/seo'
import Header from 'src/components/organisms/Header'
import Footer from 'src/components/organisms/Footer'
import SubPageTopLayout from 'src/components/organisms/SubPageTopLayout'
import {
  useCreateHbsptForm,
  addH2IndexToHTMLText,
  addHubspotFormElementToHTMLText,
  addPardotFormElementHTMLText,
} from 'src/utils/blog'
import BlogArticle from 'src/components/organisms/blog-post/BlogArticle'

const BlogTemplate = ({
  pageTitle,
  pageHeading,
  markdownRemark,
  url
}) => {
  const post = markdownRemark
  const { title, description, thumbnail } = post.frontmatter

  useCreateHbsptForm(post.html)

  const scriptTagRegExp = /<script.*>.*<\/script>/g
  const scriptTagList = post.html.match(scriptTagRegExp)
  const htmlExcludingScriptTag = post.html.replace(scriptTagRegExp, '')

  let html = addH2IndexToHTMLText(htmlExcludingScriptTag)
  html = addHubspotFormElementToHTMLText(html)
  html = addPardotFormElementHTMLText(html)

  return (
    <>
      <Helmet>
        {scriptTagList?.map(stringScriptTag => {
          return parse(stringScriptTag)
        })}
      </Helmet>
      <SEO
        title={title}
        description={description}
        image={thumbnail ? thumbnail.publicURL : ''}
      />
      <Container>
        <GlobalCSS />
        <Header />
        <SubPageTopLayout title={pageTitle} heading={pageHeading} />
        <BlogArticle title={title} url={url} articleHtml={html} />
        <Footer />
      </Container>
    </>
  )
}

const Container = styled.div`
  position: relative;
  overflow: hidden;
`

export default BlogTemplate
